module.exports = __webpack_public_path__ + "static/media/terrace-4.9fa3457d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/terrace-4.jpg
// module id = 303
// module chunks = 0